import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { arraysEqual, findArray } from 'helpers/utils'
import Competitor from "components/presentation/Competitor";
import { getRscObject } from "helpers/rsc";
import SportCode from "components/common/SportCode";
import { APPARATUS } from "components/sports/gar/helper/GarHelpers";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export const TableExpandedTeams = React.memo((props) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const gender = getRscObject(mirs_rsc).sex
    const { row } = props;
    const discipline = mirs_discipline;
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const eslData = row?.extCompetitor
    let apparatus = (gender === "M") ? APPARATUS.MEN : APPARATUS.WOMEN;


    let ArrayTrTeam = []
    let col = []


    Array.isArray(apparatus) && apparatus.forEach((item) => {
        let extendedResult = findArray(row.extendedResults, { er_code: [item] });
        col.push(<td className="text-end">{extendedResult.er_value}</td>)
    }
    )
    //ArrayTrTeam.push(<tr>{col}</tr>)



    return (
        <>
            {eslData && <div className="text-wrap text-start mirs-esl">{eslData}</div>}
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="w-5 text-end d-none d-sm-table-cell"><Label data="HeaderBib" /></th>
                        <th className="w-20 text-start"><Label data="HeaderName" /></th>
                        {gender === 'M'
                            ? (
                                <>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"FX"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"PH"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"SR"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"PB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"HB"} abbr={isMobile} /></th>
                                </>
                            )
                            : (
                                <>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"UB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"BB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"FX"} abbr={isMobile} /></th>
                                </>
                            )
                        }

                    </tr>
                </thead>
                <tbody className="mobile-small">
                    {row?.teamAthletes?.map(data => <AthletePoints data={data} key={data?.order} />)}
                    <tr className="d-table-row d-md-none ">
                        <td ></td> {col}
                    </tr>
                </tbody>
            </table>
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps, nextProps)
    )
});

const AthletePoints = ({ data }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const gender = getRscObject(mirs_rsc).sex
    return <>
        <tr>
            <td className="text-end d-none d-sm-table-cell">{data?.bib}</td>
            <td><Competitor {...data?.participantCode} hideNoc={true} hidePicture={true} /></td>
            {gender === 'M'
                ? (
                    <>
                        <td className="text-end" ><ResultAppartus data={data?.extendedResults} code="FX" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="PH" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="SR" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="VT" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="PB" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="HB" /></td>
                    </>
                )
                : (
                    <>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="VT" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="UB" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="BB" /></td>
                        <td className="text-end"><ResultAppartus data={data?.extendedResults} code="FX" /></td>
                    </>

                )
            }
        </tr>
    </>
}

const ResultAppartus = ({ data, code }) => {
    //const execution = data?.find(i => i?.er_code === code)?.extensions?.find(e => e?.ere_code === 'EXECUTION')?.ere_value
    const nodeResult = data?.find(i => i?.er_code === code);
    const discarded = nodeResult?.extensions?.find(e => e?.ere_code === 'DISCARDED')?.ere_value
    const value = nodeResult?.er_value
    const irm = nodeResult?.er_irm
    const valueType = nodeResult?.er_valuetype
    const score = (valueType === 'IRM') ? irm : value
    return (<span className={discarded === 'Y' ? 'text-decoration-line-through' : ''}>{score}</span>)
}